module.exports = {
    language: {
        name: 'English'
    },
    header: ['Home','About Us','News','Our IP','Business Scope','New Retail','Contact Us'],
    main: {
        aboutUs: 'About Us',
        news: 'News',
        ourIp: 'Our IP',
        link: 'Link',
        contactUs: 'Contact Us',
        aboutList: [],
        newsList: [],
    },
    about:{
        ip:'IP',
        banner:'',
        produce:'',
        ipList:[],//所有的轮播图的数据[[],[],[]]
        ipListActive:[],//当前的一个轮播图的数据['','','']
        ipItemList:[],//默认展示的图片
        ipItemListActive:[],//点击激活时候的图片
        coreBusiness:''
    },
    news:{
        banner:''
    },
    ip:{
        bannerList:[],
        ipNewsTitle:'IP News'
    },
    market:{
        
    },
    store: {
        banner:[],
        storeList:[]
    },
    channels:{
        bannerList:[]
    }
}